const WITHDRAW_STATUSES_PENDING: string = 'withdraw_statuses_pending';

export {
    WITHDRAW_STATUSES_PENDING
}
